{
  "(optional)": "(pasirenkama)",
  "(required)": "(privaloma)"
}
